import IconInCircle from './IconInCircle'

export default IconInCircle
